<template>
  <div>
    <GridLayout :width="500">
      <RecipeCard
        v-for="recipe in recipes"
        :key="recipe.id"
        :recipe="recipe"
        style="width: 500px;"
        @click.native="goToRecipe(recipe)"
      />
    </GridLayout>
    <InfiniteLoader v-model="loading" :schema="schema" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecipeCard from "@/pages/MyRecipes/components/RecipeCard";
import RecipeModal from "@/pages/MyRecipes/components/RecipeModal";

export default {
  name: "MyRecipesIndex",
  components: {
    RecipeCard
  },
  props: {},
  computed: {
    ...mapGetters({
      recipes: "getMyRecipes"
    })
  },
  data() {
    return {
      schema: {
        action: "fetchMyRecipes",
        getter: "getMyRecipes",
        pagination: "getMyRecipesPagination",
        clean: "resetMyRecipes"
      },
      loading: false
    };
  },
  methods: {
    goToRecipe(recipe) {
      this.$modal.show(
        RecipeModal,
        {
          recipe
        },
        {
          name: "RecipeModal",
          classes: "RecipeModal rounded-xl rounded-r-none overscroll-contain",
          transition: "vm-transition--side-card",
          height: "100%",
          maxWidth: 600,
          shiftX: 1.0,
          scrollable: true,
          adaptive: true
        }
      );
    }
  },
  created() {}
};
</script>

<style></style>
